<template>
  <div class="panel" data-qid="engagement-settings">
    <header class="panel__header">
      <div class="profile-compact">
        <div class="logo-container">
          <font-awesome-icon icon="tasks" class="icon-svg--sm"/>
        </div>
        <div class="profile-compact__info">
          <div class="profile-compact__top">
            <div class="profile-compact__text">
              {{ $t('projects.engagement.settings.steps_title') }}
            </div>
          </div>
        </div>
      </div>

      <div class="profile-compact__actions">
        <span class="icon-btn"
              v-if="canEdit && !editing"
              @click="startEditing"
              data-qid="engagement-settings-edit"
        >
          <font-awesome-icon icon="pen"/>
        </span>
        <span class="icon-btn btn-delete"
              v-if="editing"
              @click="editing = false"
              data-qid="engagement-settings-cancel">
          <font-awesome-icon icon="rotate-left"/>
        </span>
        <span class="icon-btn btn-edit"
              v-if="editing"
              @click="save"
              data-qid="engagement-settings-save">
          <font-awesome-icon icon="save"/>
        </span>
      </div>
    </header>

    <div class="panel__body">
      <p class="text-muted">{{ $t('projects.engagement.settings.steps_description') }}</p>
      <EngagementStepsPicker v-model="selectedSteps" :disabled="!editing"></EngagementStepsPicker>
    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import EngagementStepsPicker from '@/views/Projects/Engagement/EngagementStepsPicker.vue';
import { engagementPermissions } from '@/views/Projects/Engagement/engagement.js';

export default {
  name: 'EngagementSettings',
  props: {
    project: {
      type: Object,
      required: true
    },
    engagement: {
      type: Object,
      required: true
    }
  },
  components: {
    EngagementStepsPicker
  },
  data: function() {
    return {
      editing: false,
      selectedSteps: []
    }
  },
  computed: {
    canEdit() {
      return !!engagementPermissions(this.project).manage && this.project.status !== 'closed' && this.project.status !== 'completed';
    }
  },
  watch: {
    'engagement.included_steps': {
      immediate: true,
      handler(steps) {
        if (!this.editing) {
          this.selectedSteps = (steps || []).slice();
        }
      }
    }
  },
  methods: {
    startEditing() {
      this.selectedSteps = (this.engagement.included_steps || []).slice();
      this.editing = true;
    },
    save() {
      let self = this;
      piincHttp.put('projects/' + this.project.slug + '/engagement/settings', {
        engagement_steps: this.selectedSteps
      }).then(function(response) {
        self.editing = false;
        self.$toastr('success', self.$t('projects.engagement.settings.save_success'));
        self.$emit('changed', response.data);
      }, function(error) {
        self.$toastr('error', error.data && error.data.message ? error.data.message : '');
      });
    }
  }
}
</script>
